import React from "react"
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Membership from "./Membership"
import TagEditor from "./tags/TagEditor"
import "./AdminPage.css"

export default function AdminPage() {

    
    return <div id="admin">    
        <Tabs defaultActiveKey="tags">
            <Tab eventKey="tags" title="Tagovi">
                <TagEditor/>
            </Tab>
            <Tab eventKey="membership" title="Članarine">
                <Membership/>
            </Tab>
        </Tabs>
    </div>
}